import { createContext, useContext } from 'react';
import type { HomepageContextValue } from './HomepageContext';

export const HomepageContext = createContext<HomepageContextValue | null>(null);

export function useHomepage() {
  const ctx = useContext(HomepageContext);
  if (!ctx) throw new Error('useHomepage must be used within HomepageProvider');
  return ctx;
}

/**
 * Non-throwing variant: returns `null` when there is no HomepageProvider above
 * (e.g. a standalone share view). Use this from components that can render both
 * inside and outside the app shell — such as the mesh viewer, which portals its
 * download control into the feature-tree slot when the sidebar is present.
 */
export function useHomepageOptional() {
  return useContext(HomepageContext);
}
